import React from 'react'
import image from '../../../../assets/homepage_cctv.png'
import image2 from '../../../../assets/homepage_big-ico.png'
const LowerBannner = () => {
    return (
        <>
            <section className="over-hid">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="lft-grid">
                                <h3>
                                    <span>Increase your Home Security</span> With EErna CCTV Camera
                                </h3>
                                <a href="#" className="btn-buy">
                                    Shop Now
                                </a>
                                <div className="cctv-bx">
                                    <img className="img-fluid" src={image} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="rt-grid">
                                <div>
                                    <h3>Amazing Compare Product Feature</h3>
                                    <a href="#" className="btn-buy">
                                        Compare Now
                                    </a>
                                    <div className="big-ico">
                                        <img className="img-fluid" src={image2} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default LowerBannner